import Head from "next/head"
import { useRouter } from "next/router"
import { LeadWhatsappForm } from "@/forms/container/LeadWhatsappForm"
import cn from 'classnames';
const WhatsappFormPage = () => {

  const router = useRouter()
  const queryParams = router.query
  /**
   * An object containing UTM (Urchin Tracking Module) parameters extracted from query parameters.
   * These parameters are used for tracking the source and medium of traffic to the page.
   */
  const utmParams = {
    utm_content: Array.isArray(queryParams?.utm_content) ? queryParams.utm_content[0] : queryParams?.utm_content || null,
    utm_term: Array.isArray(queryParams?.utm_term) ? queryParams.utm_term.join(",") : queryParams?.utm_term || null,
    utm_campaign: Array.isArray(queryParams?.utm_campaign) ? queryParams.utm_campaign[0] : queryParams?.utm_campaign || null,
    utm_medium: Array.isArray(queryParams?.utm_medium) ? queryParams.utm_medium[0] : queryParams?.utm_medium || null,
    source: queryParams?.source,
    gclid: queryParams?.gclid || null,
  }
  const queryString = Object.entries(queryParams)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

    //   max-height: 544px;
    // max-width: 370px;
    const getEventSourceUrl = ()=>{
    try {
      return window?.top?.location.origin || window.location.origin
    } catch (error) {
      return queryParams?.event_source_url
    }
  }
  const getClientUserAgent = ()=>{
    try {
      return window?.top?.navigator.userAgent || window.navigator.userAgent
    } catch (error) {
      return queryParams?.client_user_agent
    }
  }


  return <section className="flex justify-end">
    <Head>
      <title>Whatsapp Form</title>
      <meta property="title" content="Whatsapp Form" />
    </Head>
    {/* todo: add mobile styles */}
    <section className="bg-transparent relative">
      {/* <button onClick={()=>setOpen(!open)} className="cursor-pointer outline-none no-underline fixed z-[9999] bottom-5 left-5 h-13 w-13 bg-[#25d366] rounded-full p-2 text-surface-0!" >
        <IconComponent className="text-surface-0 h-9 w-9" name="whatsapp" />
      </button> */}
      <div className={cn(" z-[9999] top-0 left-0 bg-surface-0 flex flex-col items-center justify-center min-w-[200px] max-w-[320px] h-auto w-fit",{
        // ["hidden"]:!open
      })}>
        {/* <div className="flex items-center bg-[#128c7e] w-full rounded-t-lg py-3 px-6">
          <span className="rounded-full bg-[#25d366]"><IconComponent className="text-surface-0 h-8 w-8" name="whatsapp" /></span>
          <h2 className="font-texts text-xl text-surface-0 font-semibold ml-3">WhatsApp</h2>
          <button onClick={()=>setOpen(false)} className="w-full flex justify-end"> <Close className="w-4 h-4 fill-surface-0 !text-surface-0"/></button>
        </div> */}
        <div className="flex flex-col p-6 gap-2">
          <h3 className="font-texts text-2xl text-surface-800 font-bold">Completa con tus datos</h3>
          <p className="font-texts text-base text-surface-800 font-normal">Para más información compártenos los siguientes datos</p>
          {/* todo : add utm data from src params */}
          <LeadWhatsappForm 
            utmLeads={queryString} 
            leadPhone={queryParams?.phone} 
            utmData={utmParams} 
            event_name={queryParams?.event_name} 
            event_source={queryParams?.event_source}
            send_capi={queryParams?.send_capi}
            send_gtm = {queryParams?.send_gtm}
            test_event_code={queryParams?.test_event_code}
            event_source_url={getEventSourceUrl()}
            client_user_agent={getClientUserAgent()}
            modality={(queryParams.modality ?? "")?.toString()}/>         
        </div>
      </div>
    </section>
  </section>;
}

export default WhatsappFormPage

